/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

if (!customElements.get('quick-nav-form')) {
  class QuickNav extends HTMLElement {
    constructor() {
      super();
      this.preselectedInput = this.querySelector('.custom-input[data-level="default"]');
      this.parentCheckboxes = this.querySelector('.custom-input[data-level="1"]');
      this.childSelect = this.querySelector('.custom-select[data-level="2"]');
      this.grandchildSelect = this.querySelector('.custom-select[data-level="3"]');
      this.submitButton = this.querySelector('.js-submit');
      this.priceRange = this.querySelector('.js-quick-nav-price');

      this.addEventListener('change', this.handleQuickNavChange);
      this.parseCollectionInfo("collections/in-stock","", true);  
    }


    /**
     * Handles when anything in the quick nav is changed (one of the selects)
     * @param {object} evt - Event object
     */
    handleQuickNavChange(evt) {
      //debugger;
      if (evt.target.closest("[data-level]")) {
  
         if (this.dataset.searchSelect){
            if(evt.target.tagName == "SELECT"){
              var selectedOption = evt.target.options[evt.target.selectedIndex];
            }else{
              var selectedOption = evt.target;
            }
            

            if (selectedOption.dataset.isCollection) {
            this.url = selectedOption.dataset.url;
            this.parseCollectionInfo(selectedOption.dataset.url,evt);  
            }else{
             
              if (evt.target.dataset.level === '2') {
                var parentSelectedOption = this.parentCheckboxes.querySelector('input:checked');
                if(parentSelectedOption){
                  var url = parentSelectedOption.getAttribute("data-url");
                }else{
                  var url =  this.preselectedInput.value;
                }
                
                var firstChildUrlPart = selectedOption.getAttribute("data-value") + "=" + selectedOption.value;
                this.url = url + "?"+ firstChildUrlPart;         
                this.parseCollectionInfo(this.url,evt);  
              }else if (evt.target.dataset.level === '3') {
                var parentSelectedOption = this.parentCheckboxes.querySelector('input:checked');
                 if(parentSelectedOption){
                  var url = parentSelectedOption.getAttribute("data-url");
                }else{
                  var url =  this.preselectedInput.value;
                }
                var url = parentSelectedOption.getAttribute("data-url");
                var firstChildSelectedOption = this.childSelect.options[this.childSelect.selectedIndex];
                var firstChildUrlPart = firstChildSelectedOption.getAttribute("data-value") + "=" + firstChildSelectedOption.value;
                var secondChildUrlPart = selectedOption.getAttribute("data-value") + "=" + selectedOption.value;
                this.url = url + "?"+ firstChildUrlPart +"&"+secondChildUrlPart;         
                this.parseCollectionInfo(this.url,evt);  
              }
            }  

           this.updateSubmitButton(this.url);
           

         }
      } else if (evt.target.closest('.js-quick-nav-price')) {
        const priceRangeMin = this.priceRange.querySelector("[name='filter.v.price.gte']").value;
        const priceRangeMax = this.priceRange.querySelector("[name='filter.v.price.lte']").value;

        let url = this.url; // eslint-disable-line
        if (priceRangeMin) {
          url = url.includes('?') ? `${url}&` : `${url}?`;
          url += `filter.v.price.gte=${priceRangeMin}`;
        }
        if (priceRangeMax) {
          url = url.includes('?') ? `${url}&` : `${url}?`;
          url += `filter.v.price.lte=${priceRangeMax}`;
        }
        this.updateSubmitButton(url);
        this.parseCollectionInfo(url,evt);
      } else {
        QuickNav.resetSelect(evt.target, false);
      }
    }

    /**
     * Dynamically load the price range slider and updates the number of results
     * @param {string} url - Collection url to fetch
     * @returns {Promise<void>}
     */
    async parseCollectionInfo(url,evt,defaultParse) {
      this.submitButton.classList.remove('disabled');
      this.submitButton.classList.add('is-loading');
      let preventButtonEnable = false;

      // Fetch collection page
      const response = await fetch(url);
      if (response.ok) {
        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        const productsContainer = tmpl.content.querySelector('[data-num-results]');
        if (productsContainer) {
          const numResults = parseInt(productsContainer.dataset.numResults, 10);
          if (numResults === 0) {
            this.submitButton.querySelector("span").textContent = window.languages.show_products_none;
            preventButtonEnable = true;
          } else if (numResults === 1) {
            this.submitButton.querySelector("span").textContent = window.languages.button_one.replace(
              '[quantity]',
              numResults
            );
          } else {
            this.submitButton.querySelector("span").textContent = window.languages.button_other.replace(
              '[quantity]',
              numResults
            );
          }

          
        } else {
          // eslint-disable-next-line
          console.warn(
            'Enterprise Theme: An element with [data-num-results] could not be found on the product page.',
            url
          );
        }

        if(defaultParse){
            var _this = this;       
            QuickNav.resetSelect(this.childSelect, true);
         
           
            var optionName = this.childSelect.getAttribute("data-filter");
            var filterContainer = tmpl.content.querySelectorAll('.collection__filter-group-list .collection__filter-group');
            var foundFilters = false;
            if(filterContainer.length){
              filterContainer.forEach(function(filterBlock){
                if(filterBlock.querySelector(".collection__filter-group-name")){
                     
                  if(filterBlock.querySelector(".collection__filter-group-name").innerText.trim() == optionName){
                    filterBlock.querySelectorAll(".checkbox-wrapper .checkbox").forEach(function(checkbox,index){
                      if(!checkbox.disabled){
                        var optionContentHTML = `<option data-value="${checkbox.getAttribute('name')}" value="${checkbox.value}">${checkbox.value}</option>`;
                         var optionContentElement = new DOMParser().parseFromString(optionContentHTML, 'text/html').body.childNodes[0];                     
                        _this.childSelect.appendChild(optionContentElement);   
                        foundFilters = true;
                      }
                    });
                  }
                }
              });

               if(foundFilters){
              _this.childSelect.removeAttribute('disabled');
               }           
            }
                     
            QuickNav.resetSelect(this.grandchildSelect, true);
            this.submitButton.classList.remove('is-loading');

            if (this.dataset.showPrice) {
              const priceRangeElem = tmpl.content.querySelector('price-range');
              if (priceRangeElem) {
                this.priceRange.innerHTML = priceRangeElem.outerHTML;
                this.priceRange.classList.remove("disabled-quick-nav-footer");
              } else {
                // eslint-disable-next-line
                console.warn(
                  'Enterprise Theme: No price ranger slider could be found for collection.',
                  url
                );
              }
            }
          
            return;
        }

        if (this.dataset.searchSelect){
         
          var _this = this;
          if (evt.target.dataset.level === '1' && this.childSelect) {          
            QuickNav.resetSelect(this.childSelect, true);
         
           
            var optionName = this.childSelect.getAttribute("data-filter");
            var filterContainer = tmpl.content.querySelectorAll('.collection__filter-group-list .collection__filter-group');
            var foundFilters = false;
            if(filterContainer.length){
              filterContainer.forEach(function(filterBlock){
                if(filterBlock.querySelector(".collection__filter-group-name")){
                     
                  if(filterBlock.querySelector(".collection__filter-group-name").innerText.trim() == optionName){
                    filterBlock.querySelectorAll(".checkbox-wrapper .checkbox").forEach(function(checkbox,index){
                      if(!checkbox.disabled){
                        var optionContentHTML = `<option data-value="${checkbox.getAttribute('name')}" value="${checkbox.value}">${checkbox.value}</option>`;
                         var optionContentElement = new DOMParser().parseFromString(optionContentHTML, 'text/html').body.childNodes[0];                     
                        _this.childSelect.appendChild(optionContentElement);   
                        foundFilters = true;
                      }
                    });
                  }
                }
              });

               if(foundFilters){
              _this.childSelect.removeAttribute('disabled');
               }           
            }
                     
            QuickNav.resetSelect(this.grandchildSelect, true);
          } else if (evt.target.dataset.level === '2' && this.grandchildSelect) {
            QuickNav.resetSelect(this.grandchildSelect, true);
         
           
            var optionName = this.grandchildSelect.getAttribute("data-filter");
            var filterContainer = tmpl.content.querySelectorAll('.collection__filter-group-list .collection__filter-group');
            var foundFilters = false;
            if(filterContainer.length){
              filterContainer.forEach(function(filterBlock){
                if(filterBlock.querySelector(".collection__filter-group-name")){
                     
                  if(filterBlock.querySelector(".collection__filter-group-name").innerText.trim() == optionName){
                    filterBlock.querySelectorAll(".checkbox-wrapper .checkbox").forEach(function(checkbox,index){
                      if(!checkbox.disabled){
                        var optionContentHTML = `<option data-value="${checkbox.getAttribute('name')}" value="${checkbox.value}">${checkbox.value}</option>`;
                         var optionContentElement = new DOMParser().parseFromString(optionContentHTML, 'text/html').body.childNodes[0];                     
                        _this.grandchildSelect.appendChild(optionContentElement);   
                        foundFilters = true;
                      }
                    });
                  }
                }
              });

               if(foundFilters){
              _this.grandchildSelect.removeAttribute('disabled');
               }            
            }            
          }
          
        }

        if (this.dataset.showPrice) {
          const priceRangeElem = tmpl.content.querySelector('price-range');
          if (priceRangeElem) {
            this.priceRange.innerHTML = priceRangeElem.outerHTML;
            this.priceRange.classList.remove("disabled-quick-nav-footer");
          } else {
            // eslint-disable-next-line
            console.warn(
              'Enterprise Theme: No price ranger slider could be found for collection.',
              url
            );
          }
        }
      }

      this.submitButton.classList.remove('is-loading');
    }

    /**
     * Hides the price range slider
     */
    unparseCollectionInfo() {
      if (this.priceRange) this.priceRange.classList.add("disabled-quick-nav-footer");
      this.submitButton.querySelector("span").textContent = window.languages.button_standard;
    }

    /**
     * Updates the URL on the search button
     * @param {string} url - The new URL
     */
    updateSubmitButton(url) {
      // Update the url situation
      if (url && url.length > 0 && url !== '#') {
        this.submitButton.href = url;
        this.submitButton.classList.remove('disabled');
      } else {
        this.submitButton.href = '#';
        this.submitButton.classList.add('disabled');
      }
    }

    /**
     * Resets a select back to its default state
     * @param {object} selectElem - The select element to reset
     * @param {boolean} disable - Whether the select should be disabled or not
     */
    static resetSelect(selectElem, disable) {
      if (selectElem) {
        while (selectElem.options.length > 1) {
          selectElem.options[1].remove();
        }
      }
      if(disable){
        selectElem.setAttribute("disabled","disabled");
      }
    }
  }

  customElements.define('quick-nav-form', QuickNav);
}

